/**
 * The country's day the editor and the board put Danish times on — the
 * planner's run date (today in the country, or the preview's), so the
 * timing mirror and the plan agree by construction (15/10/2026).
 * For Media Devoted | Created By Ciro Autiero
 */
import { type CountryClockDay, localDateInTz } from '@trafficpulse/shared';

export function planDay(
  plan: { recipientTimezone: string | null; windowStartMin: number },
  runDate?: string | null,
): CountryClockDay {
  const tz = plan.recipientTimezone;
  return { tz, runDate: runDate ?? localDateInTz(new Date(), tz ?? 'Europe/Copenhagen'), windowStartMin: plan.windowStartMin };
}
